import { Heading, Box, BoxProps } from '@chakra-ui/react'; // TODO: this should come from typography
import PropTypes from 'prop-types';
import React from 'react';

import { useMultiStyleConfig } from '../../system/hooks';

import DisplayNames from './enums';

export type SideBarSectionProps = BoxProps & {
  title?: string;
  rightIcon?: React.ReactElement;
};

const sideBarSectionPropTypes = {
  title: PropTypes.string,
  rightIcon: PropTypes.node
};
const sideBarSectionDefaultProps = {
  title: null,
  rightIcon: null
};
const SideBarSection = (props: SideBarSectionProps): React.ReactElement => {
  const { title, rightIcon, children, ...rest } = props;
  const { sideBarSection: themeStyles, sideBarSectionTitle: headingThemeStyles } = useMultiStyleConfig(
    'SideBar',
    props
  );

  const computedProps: BoxProps = {
    ...(themeStyles as BoxProps),
    'aria-label': `${title} sidebar section`,
    as: 'section',
    ...rest
  };

  const headingProps = headingThemeStyles as BoxProps;

  return (
    <Box {...computedProps}>
      {title && (
        <Heading as="h3" {...headingProps}>
          <Box as="span">{title}</Box>
          {rightIcon && (
            <Box as="span" marginLeft="auto">
              {rightIcon}
            </Box>
          )}
        </Heading>
      )}
      {children}
    </Box>
  );
};

SideBarSection.propTypes = sideBarSectionPropTypes;
SideBarSection.defaultProps = sideBarSectionDefaultProps;

SideBarSection.displayName = DisplayNames.SideBarSection;
export default SideBarSection;
